const toggleModal = (target) => $(target).toggleClass('active');

$(document).on('click', '[data-modal]', function () {
  $('.modal.active').removeClass('active');
  const target = $(this).data('modal');
  const unique = $(this).attr('data-modal-unique');

  toggleModal(`#modal--${target}${unique || ''}`);
  $('html').toggleClass('no-scroll');
});

$('.modal__close').on('click', function () {
  const modal = $(this).parent().parent();
  $('html').removeClass('no-scroll');
  toggleModal(modal);
});

$(document).keydown(function (e) {
  if (e.keyCode === 27) {
    const activeModal = $('.modal.active');
    if (activeModal.length) {
      $('html').removeClass('no-scroll');
      toggleModal(activeModal);
    }
  }
});
